
const filterGrades = (gradeAccess: string[], plus: boolean, apps: { [key: string]: any; }[]) => {

    const allAccess    = gradeAccess.length === 7 && plus;
    const noPlusAccess = !plus && !!apps[0].origin && (apps[0].origin === 'puzzles' || apps[0].origin === 'interaction');

    if (allAccess || noPlusAccess) {
      apps.map((val) => { val.disabled = !allAccess; return val; })
      return apps;
    }

    let newApps = [];

    for ( let i = 0; i < apps.length; i++ ) {

        if (apps[i].plus === "") {
           apps[i].plus = "0";
        }
        
        if (!!apps[i].classes) {

            let pushed = false;

            for ( let j = 0; j < gradeAccess.length; j++ ) {
               if ( apps[i].classes.includes(gradeAccess[j]) ) {
                 if (( !!apps[i].origin && apps[i].origin !== 'apps') || ( !!apps[i].origin && apps[i].origin === 'apps' && ((apps[i].plus === '1' && plus) || (apps[i].plus !== '1')))) {
                    apps[i].disabledGrade = false;
                    newApps.push(apps[i]);
                    pushed = true;
                 }
                 break;
               }
            }

            if (!pushed) {
              apps[i].disabledGrade = true;
              newApps.push(apps[i]);
            }
        } 
    }

    return newApps;
}

export default filterGrades

/* 
const sdf = {
    "actor": {
      "name": "Sally Glider",
      "mbox": "mailto:sally@example.com"
    },
    "verb": {
      "id": "http://adlnet.gov/expapi/verbs/experienced",
      "display": { "en-US": "experienced" }
    },
    "object": {
      "id": "http://example.com/activities/solo-hang-gliding",
      "definition": {
        "name": { "en-US": "Solo Hang Gliding" }
      }
    }
  } */